const plugin = require("tailwindcss/plugin");

/**
 * This plugin adds ripple effect to the buttons.
 * The ripple effect automatically adapts to the button's text color (currentColor)
 * so it works with any background color.
 * Use ripple-none to disable the ripple effect.
 * The ripple uses percentage-based sizing with aspect-ratio to ensure uniform circular animation.
 */
const ripplePlugin = plugin(function ({ addComponents }) {

  const components = {
    '.ripple-none': {
      // Empty class to disable ripple effect
    },
    '.ripple:where(:not(.ripple-none))': {
      position: 'relative', 
      overflow: 'hidden',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        aspectRatio: '1',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%) scale(4)',
        'border-radius': '50%',
        'background-color': 'currentColor',
        opacity: '0',
        transition: 'transform 0.6s, opacity 0.8s',
        'pointer-events': 'none',
      },
      '&:active::after': {
        transform: 'translate(-50%, -50%) scale(0)',
        opacity: '0.2',
        transition: '0s',
      }
    }
  };

  addComponents(components);
});

module.exports = ripplePlugin;